import React, { useState, useEffect } from 'react';
import authService from '../../api-authorization/AuthorizeService'
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { selectEventById } from './eventsSlice'
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import GoogleMapReact from 'google-map-react';
import { Map, GoogleApiWrapper, Marker  } from 'google-map-react';
import { deleteEvent } from './eventsSlice'
import Geocode from "react-geocode";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { useConfirm } from "material-ui-confirm";
import { EditorState, convertFromRaw } from 'draft-js';
/*import { Editor } from 'react-draft-wysiwyg';*/
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { format } from 'date-fns'

Geocode.setApiKey("AIzaSyAGR6fEs0PHMx4tHntVVkV6iS23G8LrxDQ");
Geocode.setLanguage("en");
Geocode.setRegion("es");
Geocode.setLocationType("ROOFTOP");

const MarkComponent = ({ text }) => <div><LocationOnIcon fontSize = 'large' style={{ color: 'red' }}/></div>;

//https://dev.to/jessicabetts/how-to-use-google-maps-api-and-react-js-26c2

export default function EventDetails({ match })
{
    const [authenticated, setAuthenticated] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isOrganizer, setIsOrganizer] = useState(false);
    const [isPlayer, setIsPlayer] = useState(false);
    const [userName, setUserName] = useState("");
    const [idType, setIdType] = useState("");
    const [playerId, setPlayerId] = useState("");
    const [userRole, setUserRole] = useState("");

    /*const { eventId } = match.params*/
    const [eventId, setEventId] = useState(match.params.eventId);
    const [event, setEvent] = useState("");
    const [eventLat, setEventLat] = useState(0);
    const [eventLng, setEventLng] = useState(0);
    const [position, setPosition] = useState({ lat: null, lng: null });
    const [mapError, setMapError] = useState(false);
    const [addressMapped, setAddressMapped] = useState(false);
    const [deleteRequestStatus, setDeleteRequestStatus] = useState("idle");

    const dispatch = useDispatch()
    const history = useHistory()
    const confirm = useConfirm();

    //https://www.npmjs.com/package/react-geocode


    const eventStatusText = ['Draft', 'Published', 'Active', 'Locked', 'Registration Closed', 'Ongoing', 'Completed', 'Archived', 'Deleted'];

    const mapStyles = {
        width: '100%',
        height: '100%',
    };
    const types = {
        TNM: 'Tournament',
        LEC: 'Lecture',
        CMP: 'Camp',
        GPL: 'Group Lesson',
        SIM: 'Simul Exhibition',
        OTH: 'Other'
    };
    const formats = {
        INP: 'In Person',
        HYB: 'Hybrid',
        OLN: 'Online',
        OTH: 'Other',
    };
    const platforms = {
        OTB: 'Over The Board',
        CHE: 'Chess.com',
        LIC: 'Lichess.org',
        C24: 'Chess24.com',
        TON: 'Tornelo',
        ZOM: 'Zoom',
        OTH: 'Other'
    };
    const entries = {
        OPN: 'Open',
        CLO: 'Closed',
        INV: 'Invitational',
        OTH: 'Other',
    };
    const pairings = {
        SWS: 'Swiss',
        RRB: 'Round Robin',
        DRR: 'Double RR',
        SCL: 'Schiller',
        SVN: 'Scheveningen (Team)',
        KNO: 'Knock Out',
        OTH: 'Other'
    };
    const timeControls = {
        CLA: 'Classical',
        DUL: 'Dual',
        RPD: 'Rapid/Quick',
        BLT: 'Blitz',
        BUL: 'Bullet',
        ODD: 'Time Odds',
        OTH: 'Other',
    };

    const [editorState, setEditorState] = useState(
        () => EditorState.createEmpty(),
    );

    useEffect(() => {

        async function fetchData() {

            setAuthenticated(await authService.isAuthenticated());
            var user = await authService.getUser();
            if (user != null) {
                var role = user.role;
                setUserName(user.sub);
                if (user.sub.includes("FIDE")) {
                    setIsPlayer(true);
                    setIdType("FIDE");
                    setPlayerId(user.sub.replace("FIDE", ""));
                } else if (user.sub.includes("Affiliate")) {
                    setIsPlayer(false);
                    setIsOrganizer(true);
                }
                else if (user.sub.includes("USCF")) {
                    setIsPlayer(true);
                    setIdType("USCF");
                    setPlayerId(user.sub.replace("USCF", ""));
                }

                setUserRole(role);
                if (role.includes("Administrators"))
                    setIsAdmin(true);
            }



            const res = await axios.get('/api/Events/' + eventId);
            const eventData = res.data;
            setEvent(eventData);

            if (eventData.eventDescriptionJSON) {
                setEditorState(() => EditorState.createWithContent(convertFromRaw(JSON.parse(eventData.eventDescriptionJSON))));
            }

            if (eventData.eventFormat !== 'OLN') {
                const address = eventData.eventAddress + "," + eventData.eventCity + "," + eventData.eventState + " " + eventData.eventZipCode;
                const encodedAddress = encodeURI(address);
                const mapAPIKey = 'AIzaSyDmo0FjaZcPnq2zZlVl9IIlkX-0AOZtaw4'; /*'AIzaSyAGR6fEs0PHMx4tHntVVkV6iS23G8LrxDQ';*/
                try {
                    const mapRes = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${encodedAddress}&key=${mapAPIKey}`);
                    const result = mapRes.data.results[0].geometry.location;

                    if (result.lat !== null && result.lng !== null) {
                        setPosition({ lat: result.lat, lng: result.lng })
                        setEventLat(result.lat);
                        setEventLng(result.lng);
                        setAddressMapped(true);
                    }
                    else {
                        setMapError(true);
                    }
                }
                catch (mapError) {
                    setMapError(true);
                }
            }
        };
        fetchData();
    }, [eventId]);

    //const onCloneEventClicked = async (confirm, event) => {

    //    confirm({ description: `This will permanently delete the event ${event.eventName}.`, confirmationText: 'Delete' })
    //        .then(
    //            async (event) => {
    //                //try {
    //                //    setDeleteRequestStatus('pending')
    //                //    await dispatch(deleteEvent({
    //                //        eventId
    //                //    })).unwrap()
    //                //    history.push(`/events/`)
    //                //}
    //                //catch (err) {
    //                //    console.error('Failed to delete the event: ', err)
    //                //}
    //                //finally {
    //                //    setDeleteRequestStatus('idle')
    //                //}
    //            }
    //        )
    //        .catch(() => console.log("Clone cancelled."));

    //}

    const onDeleteEventClicked = async (confirm,event) => {

        confirm({ description: `This will permanently delete the event ${event.eventName}.`, confirmationText: 'Delete' })
            .then(
                async (event) => {
                    try {
                        setDeleteRequestStatus('pending')
                        await dispatch(deleteEvent({
                            eventId
                        })).unwrap()
                        history.push(`/events/`)
                    }
                    catch (err) {
                        console.error('Failed to delete the event: ', err)
                    }
                    finally {
                        setDeleteRequestStatus('idle')
                    }
                }
            )
            .catch(() => console.log("Deletion cancelled."));

    }
        
    return (
        <div> { event && 
            <Card sx={{}} key={eventId} >
                {/*<CardMedia*/}
                {/*    component="img"*/}
                {/*    height="140"*/}
                {/*    alt="green iguana"*/}
                {/*/>*/}
            <CardContent>
                <Grid container direction="row" rowSpacing={1} columnSpacing={1} justify-content="space-between" align-items="stretch">
                    <Grid item xs={12} lg={8}>
                        <Typography gutterBottom variant="h5" component="div">
                            {event.eventName} [{eventStatusText[event.eventStatus]}]
                        </Typography>
                    </Grid>
                    <Grid item xs={12} lg={4}>
                        <Box display="flex" justifyContent="flex-end">
                            <Stack direction="row" spacing={1} divider={<Divider orientation="vertical" flexItem />}>
                                <Button size="small">
                                    <Link to={`/Events`} className="button">
                                        All
                                    </Link>
                                </Button>
                                <Button size="small">Share</Button>
                                    {
                                        (isAdmin || userName === event.creatorId || userName === event.OrganizerID) &&
                                                <Button size="small">
                                                    <Link to={`/editEvent/${eventId}`} className="button">
                                                        Edit
                                                    </Link>
                                                </Button>
                                    }
                                    {
                                        (isAdmin || userName === event.creatorId || userName === event.OrganizerID) &&
                                        <Button size="small">
                                            <Link to={`/cloneEvent/${eventId}`} className="button">
                                                Clone
                                            </Link>
                                        </Button>
                                    }

                                    {
                                        (isAdmin || userName === event.creatorId || userName === event.OrganizerID) &&
                                        <Button size="small" onClick={async () => onDeleteEventClicked(confirm, event)}> {/*https://stackoverflow.com/questions/34226076/why-is-my-onclick-being-called-on-render-react-js*/}
                                            Delete
                                        </Button>
                                    }
                                </Stack>
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={0.5} flexWrap='wrap'>
                            <Chip size="small" avatar={<Avatar>TY</Avatar>} title="Event Type" label={types[event.eventType]} color="success" />
                            <Chip size="small" avatar={<Avatar>FM</Avatar>} title="Format" label={formats[event.eventFormat]} color="success" />
                            <Chip size="small" avatar={<Avatar>PF</Avatar>} title="Platform" label={platforms[event.eventPlatform]} color="success" />
                            <Chip size="small" avatar={<Avatar>ET</Avatar>} title="Entries" label={entries[event.eventEntry]} color="success" />
                            <Chip size="small" avatar={<Avatar>PS</Avatar>} title="Pairing System" label={pairings[event.eventPairingSystem]} color="success" />
                            <Chip size="small" avatar={<Avatar>TC</Avatar>} title="Time Control" label={timeControls[event.eventTimeControl]} color="success" />
                            {event.eventUscfRated &&
                                <Chip size="small" avatar={<Avatar>UR</Avatar>} title="USCF Rated" label={"USCF Rated"} color="success" />
                            }
                            {event.eventUscfOnlineRated &&
                                <Chip size="small" avatar={<Avatar>UO</Avatar>} title="USCF Online Rated" label={"USCF Online Rated"} color="success" />
                            }
                            {event.eventFideRated &&
                                <Chip size="small" avatar={<Avatar>FR</Avatar>} title="FIDE Rated" label={"FIDE Rated"} color="success" />
                            }
                            {event.eventPlatformRated &&
                                <Chip size="small" avatar={<Avatar>PR</Avatar>} title="Platform Rated" label={platforms[event.eventPlatform] + " rated"} color="success" />
                            }
                            {event.eventNormPossible &&
                                <Chip size="small" avatar={<Avatar>NO</Avatar>} title="Norm Possible" label={"Norm"} color="success" />
                            }
                            

                            <Chip size="small" avatar={<Avatar>ST</Avatar>} title="Seats" label={event.eventSeats} color="success" />
                            <Chip size="small" avatar={<Avatar>RN</Avatar>} title="Rounds" label={event.eventRounds} color="success" />
                            <Chip size="small" avatar={<Avatar>PZ</Avatar>} title="Prize Fund" label={"$" + event.eventPrizeFund} color="success" />
                        </Stack>
                    </Grid>
                    <Grid item xs={12}>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} divider={<Divider orientation="vertical" flexItem />} flexWrap='wrap'>
                            <Typography variant="body2" color="text.secondary" align='left'>
                                Time Zone : {event.eventTimeZone}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" align='left'>
                                Start : {format(Date.parse(event.eventStartDateTime), 'EEE MMM dd, Y hh:mm')}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" align='left'>
                                End : {format(Date.parse(event.eventEndDateTime),'EEE MMM dd, Y HH:mm')}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" align='left'>
                                Register : {format(Date.parse(event.eventRegistrationDeadline), 'EEE MMM dd, Y HH:mm')}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" align='left'>
                                Bye : {format(Date.parse(event.eventByeRequestDeadline), 'EEE MMM dd, Y HH:mm')}
                            </Typography>
                        </Stack>
                    </Grid>
                    <Grid item xs={12}>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} divider={<Divider orientation="vertical" flexItem />} flexWrap='wrap'>
                            {event.eventFlyerUrl &&
                                <Button size="small"><a target="_blank" rel="noreferrer" href={event.eventFlyerUrl}>Flyer</a></Button>
                            }
                            {event.eventRegistrationUrl &&
                                <Button size="small"><a target="_blank" rel="noreferrer" href={event.eventRegistrationUrl}>Registration</a></Button>
                            }
                            {event.eventPairingUrl &&
                                <Button size="small"><a target="_blank" rel="noreferrer" href={event.eventPairingUrl}>Pairing & Results</a></Button>
                            }
                            {event.eventLiveGameUrl &&
                                <Button size="small"><a target="_blank" rel="noreferrer" href={event.eventLiveGameUrl}>Live Games</a></Button>
                            }
                            {event.eventHotelReservationLink &&
                                <Button size="small"><a target="_blank" rel="noreferrer" href={event.eventHotelReservationLink}>Hotel</a></Button>
                            }
                            {event.eventFideRated &&
                                <Button size="small"><a target="_blank" rel="noreferrer" href={event.eventFideRegistrationLink}>FIDE Info</a></Button>
                            }
                            {(event.eventAddress && event.eventCity && event.eventState && event.eventType !== 'OLN') &&
                                <Button size="small"><a target="_blank" rel="noreferrer" href={"https://www.google.com/maps/place/" + (event.eventAddress + "," + event.eventCity + "," + event.eventState + "," + event.eventZipCode)}>Address : {event.eventAddress + "," + event.eventCity + "," + event.eventState + "," + event.eventZipCode}</a></Button>
                            }
                        </Stack>
                    </Grid>
                    {/*<Grid item xs={12} lg={12}>*/}
                    {/*    <Typography variant="body2" color="text.secondary" align='justify'>*/}
                    {/*        {event.eventDescription}*/}
                    {/*    </Typography>*/}
                    {/*</Grid>*/}
                    <Grid item xs={12} lg={12}>
                        <Editor
                            toolbarHidden
                            editorState={editorState}
                            readOnly={true}
                            wrapperClassName="wrapper-class"
                            editorClassName="editor-class"
                            toolbarClassName="toolbar-class"
                        />
                    </Grid>
                    {/*<Grid item xs={12} lg={4} >*/}
                    {/*    <Box display="flex" justifyContent={{ xs: 'center', lg: 'flex-end' }}>*/}
                    {/*        <table>*/}
                    {/*            <tr>*/}
                    {/*                <td align="right" nowrap="nowrap">*/}
                    {/*                    <Typography variant="body2" color="text.secondary" align='right'>*/}
                    {/*                    Time Zone*/}
                    {/*                    </Typography>*/}
                    {/*                </td>*/}
                    {/*                <td align="right" nowrap="nowrap">*/}
                    {/*                    <Typography variant="body2" color="text.secondary" align='center'>*/}
                    {/*                         : */}
                    {/*                    </Typography>*/}
                    {/*                </td>*/}
                    {/*                <td align="left" nowrap="nowrap">*/}
                    {/*                    <Typography variant="body2" color="text.secondary" align='left'>*/}
                    {/*                        {event.eventTimeZone}*/}
                    {/*                    </Typography>*/}
                    {/*                </td>*/}
                    {/*            </tr>*/}
                    {/*            <tr>*/}
                    {/*                <td align="right" nowrap="nowrap">*/}
                    {/*                    <Typography variant="body2" color="text.secondary" align='right'>*/}
                    {/*                        Start*/}
                    {/*                    </Typography>*/}
                    {/*                </td>*/}
                    {/*                <td align="right" nowrap="nowrap">*/}
                    {/*                    <Typography variant="body2" color="text.secondary" align='center'>*/}
                    {/*                        :*/}
                    {/*                    </Typography>*/}
                    {/*                </td>*/}
                    {/*                <td align="left" nowrap="nowrap">*/}
                    {/*                    <Typography variant="body2" color="text.secondary" align='left'>*/}
                    {/*                        { event.eventStartDateTime }*/}
                    {/*                    </Typography>*/}
                    {/*                </td>*/}
                    {/*            </tr>*/}
                    {/*            <tr>*/}
                    {/*                <td align="right" nowrap="nowrap">*/}
                    {/*                    <Typography variant="body2" color="text.secondary" align='right'>*/}
                    {/*                        End*/}
                    {/*                    </Typography>*/}
                    {/*                </td>*/}
                    {/*                <td align="right" nowrap="nowrap">*/}
                    {/*                    <Typography variant="body2" color="text.secondary" align='center'>*/}
                    {/*                        :*/}
                    {/*                    </Typography>*/}
                    {/*                </td>*/}
                    {/*                <td align="left" nowrap="nowrap">*/}
                    {/*                    <Typography variant="body2" color="text.secondary" align='left'>*/}
                    {/*                        {event.eventEndDateTime}*/}
                    {/*                    </Typography>*/}
                    {/*                </td>*/}
                    {/*            </tr>*/}
                    {/*            <tr>*/}
                    {/*                <td align="right" nowrap="nowrap">*/}
                    {/*                    <Typography variant="body2" color="text.secondary" align='right'>*/}
                    {/*                        Register Deadline*/}
                    {/*                    </Typography>*/}
                    {/*                </td>*/}
                    {/*                <td align="right" nowrap="nowrap">*/}
                    {/*                    <Typography variant="body2" color="text.secondary" align='center'>*/}
                    {/*                        :*/}
                    {/*                    </Typography>*/}
                    {/*                </td>*/}
                    {/*                <td align="left" nowrap="nowrap">*/}
                    {/*                    <Typography variant="body2" color="text.secondary" align='left'>*/}
                    {/*                        {event.eventRegistrationDeadline}*/}
                    {/*                    </Typography>*/}
                    {/*                </td>*/}
                    {/*            </tr>*/}
                    {/*            <tr>*/}
                    {/*                <td align="right" nowrap="nowrap">*/}
                    {/*                    <Typography variant="body2" color="text.secondary" align='right'>*/}
                    {/*                        Bye Deadline*/}
                    {/*                    </Typography>*/}
                    {/*                </td>*/}
                    {/*                <td align="right" nowrap="nowrap">*/}
                    {/*                    <Typography variant="body2" color="text.secondary" align='center'>*/}
                    {/*                        :*/}
                    {/*                    </Typography>*/}
                    {/*                </td>*/}
                    {/*                <td align="left" nowrap="nowrap">*/}
                    {/*                    <Typography variant="body2" color="text.secondary" align='left'>*/}
                    {/*                        {event.eventByeRequestDeadline}*/}
                    {/*                    </Typography>*/}
                    {/*                </td>*/}
                    {/*            </tr>*/}

                                
                    {/*        </table>*/}
                    {/*    </Box>*/}
                        
                    {/*</Grid>*/}
                    {/*<Grid item xs={12}>*/}
                    {/*    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} divider={<Divider orientation="vertical" flexItem />} flexWrap='wrap'>*/}
                    {/*        {event.eventFlyerUrl &&*/}
                    {/*            <Button size="small"><a target="_blank" rel="noreferrer" href={event.eventFlyerUrl}>Flyer</a></Button>*/}
                    {/*        }*/}
                    {/*        {event.eventRegistrationUrl && */}
                    {/*            <Button size="small"><a target="_blank" rel="noreferrer" href={event.eventRegistrationUrl}>Registration</a></Button>*/}
                    {/*        }*/}
                    {/*        {event.eventPairingUrl &&*/}
                    {/*            <Button size="small"><a target="_blank" rel="noreferrer" href={event.eventPairingUrl}>Pairing & Results</a></Button>*/}
                    {/*        }*/}
                    {/*        {event.eventLiveGameUrl &&*/}
                    {/*            <Button size="small"><a target="_blank" rel="noreferrer" href={event.eventLiveGameUrl}>Live Games</a></Button>*/}
                    {/*        }*/}
                    {/*        {event.eventHotelReservationLink && */}
                    {/*            <Button size="small"><a target="_blank" rel="noreferrer" href={event.eventHotelReservationLink}>Hotel</a></Button>*/}
                    {/*        }*/}
                    {/*        {event.eventFideRated &&*/}
                    {/*            <Button size="small"><a target="_blank" rel="noreferrer" href={event.eventFideRegistrationLink}>FIDE Info</a></Button>*/}
                    {/*        }*/}
                    {/*        {(event.eventAddress && event.eventCity && event.eventState && event.eventType !== 'OLN' ) && */}
                    {/*            <Button size="small"><a target="_blank" rel="noreferrer" href={"https://www.google.com/maps/place/" + (event.eventAddress + "," + event.eventCity + "," + event.eventState + "," + event.eventZipCode)}>Address : {event.eventAddress + "," + event.eventCity + "," + event.eventState + "," + event.eventZipCode}</a></Button>*/}
                    {/*        }*/}
                    {/*    </Stack>*/}
                    {/*</Grid>*/}
                    { event.eventAddress && event.eventCity && event.eventState && event.eventType !== 'OLN' &&

                        <Grid item xs={12}>
                        {addressMapped &&
                            <div style={{ height: '30vh', width: '100%' }}>
                            
                                <GoogleMapReact
                                    bootstrapURLKeys={{ key: "AIzaSyAGR6fEs0PHMx4tHntVVkV6iS23G8LrxDQ" }}
                                    center={{ lat: eventLat, lng: eventLng }}
                                    defaultZoom={13}
                                >
                                    <MarkComponent
                                        lat={eventLat}
                                        lng={eventLng}
                                        text="Chess Venue"
                                    />
                                </GoogleMapReact>
                            </div>
                        }
                        </Grid>
                    }
                    
                </Grid>
                {/*<Grid item xs={12}>*/}
                {/*        <SectionsList/>*/}
                {/*</Grid>*/}


                </CardContent>
                {/*<CardActions>*/}
                {/*    <Button size="small">Share</Button>*/}
                {/*    <Button size="small">*/}
                {/*        <Link to={`/editEvent/${event.id}`} className="button">*/}
                {/*            Edit Event*/}
                {/*        </Link>*/}
                {/*    </Button>*/}
                {/*</CardActions>*/}
            </Card>
        }
        
            </div>
        
    )
}


